import React, { useMemo } from 'react';
import type { Route } from '../../../types';
import type { RouteViewModel } from '../../../types/routeViewModel';
import type { CorrectionContext } from '../hooks/useCorrectionContext';
import { buildCorrectionRouteContextView } from '../context/buildCorrectionRouteContextView';
import { CorrectionRouteContextPanel } from '../context/CorrectionRouteContextPanel';
import type { CorrectionScenarioId } from '../scenarios/correctionScenarioTypes';
import { CorrectionWorkspaceHeader } from './CorrectionWorkspaceHeader';
import { CorrectionOperationEditor } from './CorrectionOperationEditor';
import './correctionWorkspaceShell.css';

type Props = {
  route: Route;
  routeId: number;
  view: RouteViewModel;
  ctx: CorrectionContext;
  selectedScenarioId: CorrectionScenarioId | null;
  onSelectScenario: (id: CorrectionScenarioId) => void;
  onSuccess: () => void;
};

export function CorrectionWorkspaceShell({
  route,
  routeId,
  view,
  ctx,
  selectedScenarioId,
  onSelectScenario,
  onSuccess
}: Props) {
  const contextModel = useMemo(
    () => buildCorrectionRouteContextView({ route, view, ctx }),
    [route, view, ctx]
  );

  return (
    <div className="correction-workspace">
      <CorrectionWorkspaceHeader
        ctx={ctx}
        selectedScenarioId={selectedScenarioId}
        onSelectScenario={onSelectScenario}
      />

      <div className="correction-workspace-body">
        <div className="correction-workspace-editor">
          {selectedScenarioId ? (
            <CorrectionOperationEditor
              scenarioId={selectedScenarioId}
              route={route}
              routeId={routeId}
              view={view}
              ctx={ctx}
              onSuccess={onSuccess}
            />
          ) : (
            <div className="correction-workspace-editor-placeholder">
              Выберите действие в списке выше, чтобы открыть редактор операции.
            </div>
          )}
        </div>

        <div className="correction-workspace-context-sticky">
          <div className="correction-workspace-context-card">
            <CorrectionRouteContextPanel model={contextModel} />
          </div>
        </div>
      </div>
    </div>
  );
}
